module.exports = __webpack_public_path__ + "media/images/country_flags/mc-bdcb9e05970a197de579df56438c05a9.png";